// Config

var config = {

  route: {
    page: "public",
    view: "gallery",
    path: "/gallery",
  },

  views: [
    "login",
    "register",
    "landing",
    "creator",
    "gallery",
  ],

};
